<!-- Dialog de connection globale à l'application -->
<div class="loginTitle" mat-dialog-title>
    <div class="dialogTitle">
        <!-- Titre -->
        <h2>{{ getTitle() }}</h2>
        <h3 *ngIf="getSubTitle().indexOf('Se connecter ou') == -1" style="margin-bottom: 7px;">
            {{ getSubTitle() }}
        </h3>
    </div>

    <!-- Bouton de fermeture de la popup -->
    <mat-icon class="closeBtn" (click)="backToStore()">close</mat-icon>
</div>

<!-- Contenu -->
<mat-dialog-content id="dialogContent">
    <!-- Mode Connection avec Mdp - CurrentMode === 0 -->
    <ng-container *ngIf="currentMode === 0 || currentMode === 4">
        @if (!isTryingToLogIn) {
        <div class="firebaseBtns" *ngIf="!isTryingToLogIn">
            <!-- Google Auth -->
            <button mat-flat-button (click)="loginGoogle()">
                <mat-icon svgIcon="google_Icon"></mat-icon>
                <span id="auth-label">avec Google</span>
            </button>
            <!-- Facebook Auth -->
            <button mat-flat-button class="fb-Btn" (click)="loginFacebook()">
                <mat-icon
                    class="facebookIcon"
                    svgIcon="facebook_Icon"
                ></mat-icon>
                <span id="auth-label">avec Facebook</span>
            </button>
        </div>
        <div class="firebaseBtns" style="margin-top: 10px">
            <button mat-flat-button (click)="loginMicrosoft()">
                <mat-icon svgIcon="microsoft_Icon"></mat-icon>
                <span id="auth-label">avec Microsoft</span>
            </button>

            <!-- Twitter - X Auth -->
            <button mat-flat-button (click)="loginTwitter()">
                <mat-icon svgIcon="twitter_Icon"></mat-icon>
                <span id="auth-label">avec X</span>
            </button>
        </div>
        }

        <div class="firebaseLoader" *ngIf="isTryingToLogIn">
            <mat-spinner [diameter]="50"></mat-spinner>
            <i>Connexion...</i>
        </div>

        <!-- Form Login / Mdp - CurrentMode === 0 -->
        <div
            class="connectionFormContainer couple-column"
            *ngIf="currentMode === 0"
        >
            <h2>Ou</h2>
            <!-- Login -->
            <mat-form-field appearance="outline">
                <mat-label>Nom d'utilisateur ou Adresse mail</mat-label>
                <input
                    [disabled]="isTryingToLogIn"
                    type="text"
                    name="username"
                    id="login"
                    matInput
                    autocomplete="username"
                    inputmode="email"
                    [(ngModel)]="username"
                    (keydown.enter)="signIn()"
                    maxlength="500"
                />
            </mat-form-field>
            <!-- Password -->
            <mat-form-field appearance="outline">
                <mat-label>Mot de passe</mat-label>
                <input
                    [type]="hidePassword ? 'password' : 'text'"
                    name="password"
                    id="pass"
                    matInput
                    type="password"
                    autocomplete="current-password"
                    [(ngModel)]="password"
                    (keydown.enter)="signIn()"
                />
                <mat-icon matSuffix (click)="hidePassword = !hidePassword">{{
                    hidePassword ? "visibility_off" : "visibility"
                }}</mat-icon>
                <!-- <mat-error *ngIf="controls.password.hasError('minlength')"
                    >Le mot de passe doit contenir au moins
                    <b>6</b> caractères</mat-error
                > -->
            </mat-form-field>
            <span class="forgotPassword" (click)="currentMode = 3"
                >Mot de passe oublié ?</span
            >
            <div class="connexionBtnContainer">
                <button
                    *ngIf="currentMode === 0"
                    [disabled]="
                        isTryingToLogIn ||
                        username == null ||
                        username == '' ||
                        password == null ||
                        password == ''
                    "
                    (click)="signIn()"
                    mat-flat-button
                    color="primary"
                    class="login-btn connexionBtn"
                >
                    <mat-spinner
                        class="buttonLoader"
                        *ngIf="isTryingToLogIn"
                        [diameter]="20"
                    ></mat-spinner>
                    Connexion
                </button>
            </div>
        </div>
        <!-- MARK: Form Search Login - CurrentMode === 4 -->
        <div class="connectionFormContainer" *ngIf="currentMode === 4">
            <h2>Ou</h2>

            <!-- SearchLogin -->
            <mat-form-field appearance="outline">
                <mat-label>Login ou Adresse mail</mat-label>
                <input
                    [disabled]="isTryingToLogIn"
                    type="text"
                    name="searchUserName"
                    id="searchedLogin"
                    matInput
                    placeholder="Login / Mail"
                    autocomplete="email"
                    inputmode="email"
                    [(ngModel)]="searchUserName"
                    (keydown.enter)="searchExistingUser()"
                    maxlength="500"
                />
                <button
                    [disabled]="
                        searchUserName == null ||
                        searchUserName === '' ||
                        isTryingToLogIn
                    "
                    matSuffix
                    color="primary"
                    (click)="searchExistingUser()"
                    mat-flat-button
                    class="inputEndBtn"
                >
                    <mat-icon>arrow_right_alt</mat-icon>
                </button>
            </mat-form-field>

            <!-- Bouton pour validation de mail -->
            @if (hasToValidMail) {
            <div style="margin-bottom: 20px; margin-top: 15px">
                <p>
                    Vous devez vérifier votre adresse mail pour vous connecter à
                    Wanview
                    <br />
                    Pour ce faire, cliquez sur le lien de validation que nous
                    vous avons envoyé par mail
                </p>

                <button
                    (click)="reSendValidationMail()"
                    style="margin: auto; display: flex"
                    mat-stroked-button
                    color="primary"
                >
                    <mat-icon>mail</mat-icon>
                    Renvoyer le mail
                </button>
            </div>
            }
        </div>
        <div class="loginActionContainer">
            <hr class="splitHr" />

            <h2 class="blueTitle">Créer un compte</h2>
            <button
                [disabled]="isTryingToLogIn"
                mat-flat-button
                color="primary"
                class="login-btn register-btn"
                (click)="currentMode = 2; sendEvent('no_account_yet');"
            >
                Pas encore de compte ? (2min)
            </button>
        </div>
    </ng-container>

    <!-- Form 2FA Code -->
    <div *ngIf="currentMode === 1" class="codeFormContainer">
        <p>
            {{ twoFAInfo }}
        </p>

        <mat-form-field appearance="outline">
            <mat-label>Code</mat-label>
            <input
                #twoFAInput
                type="text"
                name="code2FA"
                id="twoFACode"
                [(ngModel)]="twoFACode"
                autocomplete="off"
                matInput
                (keydown.enter)="signIn()"
            />
        </mat-form-field>

        <button
            (click)="signIn()"
            mat-flat-button
            color="primary"
            class="login-btn"
        >
            <mat-spinner [diameter]="20" *ngIf="tryToBeLogged"></mat-spinner>
            Vérifier
        </button>
    </div>

    <!-- Form New Register new User - Part 1 -->
    <div *ngIf="currentMode === 2" class="registerFormContainer">
        <h4>Faisons plus ample connaissance</h4>
        <div class="couple-inline">
            <!-- First Name -->
            <mat-form-field appearance="outline">
                <mat-label>Quel est votre prénom ?</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input
                    type="text"
                    name="firstName"
                    id="firstName"
                    matInput
                    required
                    autocomplete="given-name"
                    maxlength="30"
                    [formControl]="controls.firstName"
                />
                <mat-error
                    *ngIf="loginForm.get('firstName').hasError('required')"
                    >Le prénom est <b>requis</b></mat-error
                >
            </mat-form-field>

            <!-- Last Name -->
            <mat-form-field appearance="outline">
                <mat-label>Et votre nom ?</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input
                    type="text"
                    name="lastName"
                    id="lastName"
                    required
                    matInput
                    autocomplete="family-name"
                    [formControl]="controls.lastName"
                    maxlength="30"
                />
                <mat-error>Le nom est <b>requis</b></mat-error>
            </mat-form-field>
        </div>

        <h4>Comment pouvons nous vous contacter ?</h4>
        <div class="couple-column">
            <!-- Phone number -->
            <mat-form-field appearance="outline">
                <mat-label>Numéro de téléphone</mat-label>
                <mat-icon matPrefix>phone</mat-icon>
                <input
                    type="tel"
                    name="phoneNumber"
                    id="phoneNumber"
                    matInput
                    required
                    autocomplete="tel"
                    [formControl]="controls.phoneNumber"
                    maxlength="10"
                />
                <mat-error *ngIf="controls.phoneNumber.hasError('required')"
                    >Le numéro de téléphone est <b>requis</b></mat-error
                >
                <mat-error *ngIf="controls.phoneNumber.hasError('pattern')">{{
                    controls.phoneNumber.getErrorMessage("pattern")
                }}</mat-error>
            </mat-form-field>

            <!-- Mail -->
            <mat-form-field appearance="outline">
                <mat-label>Adresse mail</mat-label>
                <mat-icon matPrefix>mail</mat-icon>
                <input
                    type="email"
                    name="email"
                    id="email"
                    matInput
                    required
                    autocomplete="email"
                    [formControl]="controls.email"
                    maxlength="320"
                />
                <mat-error *ngIf="controls.email.hasError('required')"
                    >Le mail est <b>requis</b></mat-error
                >
                <mat-error *ngIf="controls.email.hasError('email')"
                    >Veuillez entrer un mail valide</mat-error
                >
                <mat-error *ngIf="controls.email.hasError('existingMail')">
                    Cette adresse mail est déjà utilisée</mat-error
                >
            </mat-form-field>
        </div>
        <ng-container *ngIf="!firebaseUID">
            <h4>Avec quel mot de passe souhaitez-vous vous connecter ?</h4>
            <div class="couple-inline">
                <!-- Password -->
                <mat-form-field appearance="outline" class="passField">
                    <mat-label>Mot de passe</mat-label>
                    <mat-icon matPrefix>lock</mat-icon>
                    <input
                        [type]="hideNewUserPass ? 'password' : 'text'"
                        name="password"
                        id="password"
                        matInput
                        required
                        type="password"
                        autocomplete="new-password"
                        [formControl]="controls.password"
                        maxlength="256"
                    />
                    <mat-error *ngIf="controls.password.hasError('required')"
                        >Le mot de passe est <b>requis</b></mat-error
                    >
                    <!-- <mat-error *ngIf="controls.password.hasError('minlength')"
                        >Le mot de passe doit contenir au moins
                        <b>{{ controls.password.minLengthValue }}</b>
                        caractères</mat-error
                    > -->
                    <mat-error *ngIf="controls.password.hasError('pattern')">{{
                        controls.password.getErrorMessage("pattern")
                    }}</mat-error>
                    <button
                        tabindex="-1"
                        matSuffix
                        mat-icon-button
                        (click)="hideNewUserPass = !hideNewUserPass"
                    >
                        <mat-icon>{{
                            hideNewUserPass ? "visibility_off" : "visibility"
                        }}</mat-icon>
                    </button>
                </mat-form-field>
                <!-- ConfirmPassword -->
                <mat-form-field appearance="outline" class="passField">
                    <mat-label>Confirmer votre mot de passe</mat-label>
                    <mat-icon matPrefix>lock</mat-icon>
                    <input
                        [type]="hideNewUserPass ? 'password' : 'text'"
                        name="confirmPassword"
                        id="confirmPassword"
                        matInput
                        required
                        type="password"
                        autocomplete="new-password"
                        [formControl]="controls.confirmPassword"
                        maxlength="256"
                    />
                    <mat-error
                        *ngIf="controls.confirmPassword.hasError('required')"
                    >
                        Confirmer le mot de passe est <b>requis</b></mat-error
                    >
                    <!-- <mat-error
                        *ngIf="controls.confirmPassword.hasError('minlength')"
                        >Le mot de passe doit contenir au moins
                        <b>{{ controls.confirmPassword.minLengthValue }}</b>
                        caractères</mat-error
                    > -->

                    <button
                        tabindex="-1"
                        matSuffix
                        mat-icon-button
                        (click)="hideNewUserPass = !hideNewUserPass"
                    >
                        <mat-icon>{{
                            hideNewUserPass ? "visibility_off" : "visibility"
                        }}</mat-icon>
                    </button>
                </mat-form-field>
            </div>
            <!-- Dynamic password checker -->
            <div class="checkerContainer" *ngIf="controls.password.value">
                <div class="password-checker">
                    <mat-icon
                        class="icon text-success"
                        *ngIf="
                            !controls.password.hasError('minlength') &&
                            controls.password.value &&
                            controls.password.value.length > 7
                        "
                        >check</mat-icon
                    >
                    <mat-icon
                        class="icon text-danger"
                        *ngIf="
                            controls.password.hasError('minlength') ||
                            !controls.password.value ||
                            controls.password.value.length < 8
                        "
                        >clear</mat-icon
                    >
                    <p
                        class="text"
                        [ngClass]="[
                            !controls.password.hasError('minlength') &&
                            controls.password.value &&
                            controls.password.value.length > 7
                                ? 'text-success'
                                : 'text-danger'
                        ]"
                    >
                        8 caractères minimum
                    </p>
                </div>
                <div class="password-checker">
                    <mat-icon
                        class="icon text-success"
                        *ngIf="
                            haveLowercase(controls.password) &&
                            controls.password.value
                        "
                        >check</mat-icon
                    >
                    <mat-icon
                        class="icon text-danger"
                        *ngIf="
                            !haveLowercase(controls.password) ||
                            !controls.password.value
                        "
                        >clear</mat-icon
                    >
                    <p
                        class="text"
                        [ngClass]="[
                            haveLowercase(controls.password) &&
                            controls.password.value
                                ? 'text-success'
                                : 'text-danger'
                        ]"
                    >
                        1 minuscule
                    </p>
                </div>
                <div class="password-checker">
                    <mat-icon
                        class="icon text-success"
                        *ngIf="haveUppercase(controls.password)"
                        >check</mat-icon
                    >
                    <mat-icon
                        class="icon text-danger"
                        *ngIf="!haveUppercase(controls.password)"
                        >close</mat-icon
                    >
                    <p
                        class="text"
                        [ngClass]="[
                            haveUppercase(controls.password)
                                ? 'text-success'
                                : 'text-danger'
                        ]"
                    >
                        1 majuscule
                    </p>
                </div>
                <div class="password-checker">
                    <mat-icon
                        class="icon text-success"
                        *ngIf="haveNumber(controls.password)"
                        >check</mat-icon
                    >
                    <mat-icon
                        class="icon text-danger"
                        *ngIf="!haveNumber(controls.password)"
                        >close</mat-icon
                    >
                    <p
                        class="text"
                        [ngClass]="[
                            haveNumber(controls.password)
                                ? 'text-success'
                                : 'text-danger'
                        ]"
                    >
                        1 chiffre
                    </p>
                </div>
                <div class="password-checker">
                    <mat-icon
                        class="icon text-success"
                        *ngIf="haveSpecialCharacters(controls.password)"
                        >check</mat-icon
                    >
                    <mat-icon
                        class="icon text-danger"
                        *ngIf="!haveSpecialCharacters(controls.password)"
                        >close</mat-icon
                    >
                    <p
                        class="text"
                        [ngClass]="[
                            haveSpecialCharacters(controls.password)
                                ? 'text-success'
                                : 'text-danger'
                        ]"
                    >
                        1 caractère spécial
                    </p>
                </div>
                <div class="password-checker" *ngIf="loginForm.errors?.notSame">
                    <mat-icon
                        class="icon text-danger"
                        *ngIf="!haveSpecialCharacters(controls.password)"
                        >close</mat-icon
                    >
                    <p
                        class="text"
                        [ngClass]="[
                            !loginForm.errors?.notSame
                                ? 'text-success'
                                : 'text-danger'
                        ]"
                    >
                        Les mots de passe ne correspondent pas
                    </p>
                </div>
            </div>
        </ng-container>

        <!-- Validation -->
        <div class="couple-column">
            <button
                mat-flat-button
                color="primary"
                (click)="continueRegister()"
            >
                Suivant
            </button>
            <button mat-flat-button (click)="cancelRegister()">Retour</button>
        </div>
    </div>

    <!-- Form new Register new User - Part 2 -->
    <div *ngIf="currentMode === 22" class="registerFormContainer">
        <ng-container *ngIf="!isAccountCreating">
            <h4>Nous y sommes presque</h4>
            <div class="couple-column">
                <!-- Raison sociale -->
                <mat-form-field appearance="outline">
                    <mat-label
                        >Quelle est la raison sociale de votre entreprise
                        ?</mat-label
                    >
                    <input
                        type="text"
                        name="orgaName"
                        id="orgaName"
                        matInput
                        autocomplete="organization"
                        [formControl]="controls.orgaName"
                        required
                        maxlength="200"
                    />
                    <mat-hint align="end">
                        {{ controls.orgaName.value?.length }} / 200
                    </mat-hint>
                    <mat-error *ngIf="controls.orgaName.hasError('required')">
                        La raison sociale est <b>requise</b>
                    </mat-error>
                </mat-form-field>

                <!-- Siret -->
                <mat-form-field appearance="outline">
                    <mat-label>Et son siret ?</mat-label>
                    <input
                        type="text"
                        name="siret"
                        id="siret"
                        matInput
                        [formControl]="controls.siret"
                        required
                        maxlength="14"
                        inputmode="numeric"
                    />
                    <mat-hint align="end"
                        >{{ controls.siret.value?.length }} / 14</mat-hint
                    >
                    <mat-error *ngIf="controls.siret.hasError('required')"
                        >Le SIRET est <b>requis</b></mat-error
                    >
                    <mat-error *ngIf="controls.siret.hasError('pattern')">{{
                        controls.siret.getErrorMessage("pattern")
                    }}</mat-error>

                    <!-- Search SIRET -->
                    <button
                        [disabled]="isSIRETLoading"
                        mat-flat-button
                        *ngIf="
                            controls.orgaName.value != null &&
                            controls.orgaName.value != ''
                        "
                        color="secondary"
                        class="siretBtn"
                        (click)="getCompanySIRET(controls.orgaName.value)"
                    >
                        <mat-spinner
                            class="buttonLoader"
                            *ngIf="isSIRETLoading"
                            [diameter]="20"
                        ></mat-spinner>
                        <mat-icon class="iconInput">search</mat-icon>
                        <span class="textIconInput">
                            Rechercher le SIRET de "{{
                                controls.orgaName.value
                            }}"
                        </span>
                    </button>

                    <!-- Liste des Orga pour trouver le bon SIRET -->
                    <div
                        class="activityContainer"
                        *ngIf="siretOptions?.length > 0"
                    >
                        <h3>
                            Sélectionner le siret correspondant à votre
                            entreprise
                        </h3>
                        <div
                            class="activity"
                            *ngFor="let siretOpt of siretOptions"
                            (click)="changeSiret(siretOpt)"
                        >
                            <span class="categoryItem"
                                >{{
                                    siretOpt.uniteLegale.denominationUniteLegale
                                }}
                            </span>
                            <span
                                class="categoryItem cityInfo"
                                style="margin-left: 5px"
                                >{{
                                    siretOpt.adresseEtablissement
                                        .libelleCommuneEtablissement
                                }}
                                -
                                {{
                                    siretOpt.adresseEtablissement
                                        .codePostalEtablissement
                                }}</span
                            >
                            <span class="selectionMention">Sélectionner</span>
                            <p class="siretNumber">{{ siretOpt.siret }}</p>
                        </div>
                    </div>
                </mat-form-field>
   

                <mat-form-field appearance="outline">
                    <mat-label>Status juridique</mat-label>
                    <mat-select [(ngModel)]="controls.organizationTypeId.value" name="Status juridique">
                        <ng-container *ngFor="let option of companyTypeOption">
                            <mat-option  [value]="option.id">{{option.name}}</mat-option>

                        </ng-container>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="couple-column" style="margin-bottom: 10px">
                <mat-form-field appearance="outline">
                    <mat-label>
                        Quelle est votre adresse principale?
                    </mat-label>
                    <input
                        id="addresseSearch"
                        [disabled]="isPositionLoading"
                        matInput
                        required
                        type="text"
                        autocomplete="address-level1"
                        [formControl]="controls.orgaAddress"
                        placeholder="Sélectionnez parmi les résultats"
                    />
                    <button
                        *ngIf="isAddressSelected"
                        matSuffix
                        mat-icon-button
                        aria-label="Clear"
                        (click)="controls.orgaAddress.setValue(null)"
                    >
                        <mat-icon class="roundButtonIcon">close</mat-icon>
                    </button>
                    <mat-error *ngIf="controls.orgaAddress.hasError('required')"
                        >L'adresse de l'entreprise est <b>requise</b></mat-error
                    >

                    <!-- Geolocalisation -->
                    <button
                        [disabled]="isPositionLoading"
                        mat-flat-button
                        color="secondary"
                        class="geolocateButton"
                        (click)="getUserLocation()"
                    >
                        <mat-icon *ngIf="isPositionLoading">
                            <mat-spinner [diameter]="15"></mat-spinner>
                        </mat-icon>
                        <mat-icon *ngIf="!isPositionLoading" class="iconInput">
                            my_location
                        </mat-icon>
                        <span class="textIconInput"> Me géolocaliser </span>
                    </button>
                </mat-form-field>

                <ng-container *ngIf="!isAddressSelected">
                    <div
                        class="activity"
                        *ngFor="let addOpt of addresseOptions"
                        (click)="
                            controls.orgaAddress.setValue(addOpt, {
                                emitEvent: false
                            });
                            isAddressSelected = true
                        "
                    >
                        <span class="categoryItem">{{ addOpt }}</span>
                        <span class="selectionMention">Sélectionner</span>
                    </div>
                </ng-container>
            </div>

            <div
                class="couple-column"
                id="activityContainer"
                style="margin-top: -20px"
            >
                <mat-progress-bar
                    class="progressBar"
                    *ngIf="activitiesLoading"
                    mode="query"
                ></mat-progress-bar>
                <!-- Search Activity Input -->
                <mat-form-field
                    id="activityInput"
                    *ngIf="!controls.orgaActivityId.value"
                    appearance="outline"
                    class="sticky"
                >
                    <mat-error
                        *ngIf="controls.orgaActivityId.hasError('required')"
                        >{{
                            controls.orgaActivityId.getErrorMessage("required")
                        }}</mat-error
                    >
                    <mat-label>Quelle est votre activité? </mat-label>
                    <mat-icon matPrefix>search</mat-icon>
                    <input
                        type="text"
                        name="searchActivity"
                        id="searchActivity"
                        matInput
                        [formControl]="controls.orgaActivitysearch"
                        placeholder="Tapez pour filtrer les activités disponibles"
                        #act
                    />
                    <!-- (focus)="anchorActivity()" -->

                    <div
                        class="activityContainer"
                        *ngIf="!controls.orgaActivityId.value"
                    >
                        <div *ngFor="let activityCategory of activityOptions">
                            <span
                                class="categoryName"
                                *ngIf="activityCategory.activities?.length > 0"
                                >{{ activityCategory.name }}</span
                            >
                            <div
                                (click)="selectActivity(activity)"
                                class="activity"
                                *ngFor="
                                    let activity of activityCategory.activities
                                "
                            >
                                <span class="categoryItem">{{
                                    activity.name
                                }}</span>
                                <span class="selectionMention"
                                    >Sélectionner</span
                                >
                            </div>
                        </div>
                        <div
                            class="activity"
                            *ngIf="
                                activityOptions.length <= 0 &&
                                controls.orgaActivitysearch.value != null &&
                                !activitiesLoading
                            "
                        >
                            <span class="categoryItem"
                                >Pas d'activité correspondante</span
                            >
                        </div>
                    </div>
                </mat-form-field>
                <div
                    class="activity selected"
                    *ngIf="controls.orgaActivityId.value"
                >
                    <span class="categoryItem selected">{{
                        controls.orgaActivityId.value.name
                    }}</span>
                    <button
                        style="margin-right: 20px"
                        mat-icon-button
                        (click)="resetActivity()"
                    >
                        <mat-icon class="roundButtonIcon">close</mat-icon>
                    </button>
                </div>
            </div>
            <!-- Validation -->
            <div class="couple-column routerForm">
                <button
                    mat-flat-button
                    color="primary"
                    (click)="continueRegister2();"
                >
                    Suivant
                </button>
                <button mat-flat-button (click)="cancelRegisterPart2()">
                    Retour
                </button>
            </div>
        </ng-container>

        <div class="loaderContainer" *ngIf="isAccountCreating">
            <mat-spinner style="margin: auto" [diameter]="50"></mat-spinner>
            <i>Création de votre compte Wanview, veuillez patienter...</i>
        </div>
    </div>

    <!-- Form new Register new User - Part 3 Facultative (couleurs) -->
    <div *ngIf="currentMode === 21" class="registerFormContainer">
        <ng-container *ngIf="!isAccountCreating">
            <h4>Définissez vos couleurs - Facultatif</h4>
            <div class="info">
                <mat-icon>info</mat-icon>
                <div>
                    <p>Ces couleurs seront utilisées pour personnaliser vos modèles d'animation.</p>
                    <p>Vous pourrez les modifier et en ajouter à tout moment.</p>
                    <!-- <p>Des palettes publiques sont également disponibles pour vous aidez à créer vos spots.</p> -->
                    <p>Ne remplissez que les couleurs qui vous sont utiles.</p>
                </div>
            </div>
            <div class="couple-column">
                <!-- Raison sociale -->
                <article class="colorArticle">
                    <h3>Couleur primaire : </h3>
                    <p><span>{{colorPalette.first}}</span><input [(colorPicker)]="colorPalette.first" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="colorPalette.first"/></p>
                </article>
                <article class="colorArticle">
                    <h3>Couleur secondaire : </h3>
                    <p><span>{{colorPalette.second}}</span><input [(colorPicker)]="colorPalette.second" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="colorPalette.second"/></p>
                </article>
                <article class="colorArticle">
                    <h3>Couleur tertiaire : </h3>
                    <p><span>{{colorPalette.third}}</span><input [(colorPicker)]="colorPalette.third" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="colorPalette.third"/></p>
                </article>
                <article class="colorArticle">
                    <h3>Couleur quaternaire : </h3>
                    <p><span>{{colorPalette.fourth}}</span><input [(colorPicker)]="colorPalette.fourth" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="colorPalette.fourth"/></p>
                </article>
                <article class="colorArticle">
                    <h3>Couleur complémentaire : </h3>
                    <p><span>{{colorPalette.fifth}}</span><input [(colorPicker)]="colorPalette.fifth" [cpAlphaChannel]="'disabled'" [cpOKButton]="true"  [style.background]="colorPalette.fifth"/></p>
                </article>
            </div>

            <!-- Validation -->
            <div class="couple-column routerForm">
                <button
                    mat-flat-button
                    color="primary"
                    (click)="continueRegister3()"
                >
                    Suivant
                </button>
                <button mat-flat-button (click)="cancelRegisterPart3()">
                    Retour
                </button>
            </div>
        </ng-container>

        <div class="loaderContainer" *ngIf="isAccountCreating">
            <mat-spinner style="margin: auto" [diameter]="50"></mat-spinner>
            <i>Création de votre compte Wanview, veuillez patienter...</i>
        </div>
    </div>

    <!-- Info when User registered ! -->
    <div class="finishedContainer" *ngIf="currentMode === 23">
        <div class="recapContainer">
            <h4>Vos informations</h4>
            <div class="couple-inline">
                <!-- Recap Prénom -->
                <div class="recapItem">
                    <p>Prénom</p>
                    <p>
                        <b>{{ loginForm.get("firstName").value }}</b>
                    </p>
                </div>
                <!-- Recap Nom -->
                <div class="recapItem">
                    <p>Nom</p>
                    <p>
                        <b>{{ loginForm.get("lastName").value }}</b>
                    </p>
                </div>
            </div>
            <div class="couple-inline">
                <!-- Recap Mail -->
                <div class="recapItem">
                    <p>Adresse mail</p>
                    <p>
                        <b>{{ loginForm.get("email").value }}</b>
                    </p>
                </div>
                <!-- Numéro de téléphone -->
                <div class="recapItem">
                    <p>Numéro de téléphone</p>
                    <p>
                        <b>{{ loginForm.get("phoneNumber").value }}</b>
                    </p>
                </div>
            </div>
        </div>

        <div class="recapContainer">
            <h4>Votre entreprise</h4>

            <div class="couple-inline">
                <div class="recapItem">
                    <p>Nom</p>
                    <p>
                        <b>{{ loginForm.get("orgaName").value }}</b>
                    </p>
                </div>
                <div class="recapItem">
                    <p>Siret</p>
                    <p>
                        <b>{{ loginForm.get("siret").value }}</b>
                    </p>
                </div>
            </div>
            <div class="couple-inline">
                <div class="recapItem">
                    <p>Status juridique</p>
                    <p>
                        <b>{{ getOrganizationTypeName(loginForm.get("organizationTypeId").value) }}</b>
                    </p>
                </div>
              
            </div>

            <div class="couple-inline">
                <div class="recapItem">
                    <p>Activité</p>
                    <p>
                        <b>{{ loginForm.get("orgaActivityId").value?.name }}</b>
                    </p>
                </div>
                <div class="recapItem">
                    <p>Adresse</p>
                    <p>
                        <b>{{ loginForm.get("orgaAddress").value }}</b>
                    </p>
                </div>
            </div>
            <div class="couple-inline">
                <div class="recapItem">
                    <p>Vos couleurs</p>
                    <div id="colorContainer">
                        <span class="colorItem" [style.background]="colorPalette.first"></span>
                        <span class="colorItem" [style.background]="colorPalette.second"></span>
                        <span class="colorItem" [style.background]="colorPalette.third"></span>
                        <span class="colorItem" [style.background]="colorPalette.fourth"></span>
                        <span class="colorItem" [style.background]="colorPalette.fifth"></span>
                    </div>
                </div>
            </div>

            <!-- Validation CGV / CGU -->
            <!-- CGV -->
            <mat-checkbox [(ngModel)]="isCGVok" [required]="true">
                J'accepte les
                <a
                    href="/account-detail/cgv"
                    target="_blank"
                    style="margin-right: 3px"
                >
                    Conditions générales de Vente
                </a>
                * (requis)
            </mat-checkbox>
            <!-- CGU -->
            <mat-checkbox [(ngModel)]="isCGUok" [required]="true">
                J'accepte les
                <a href="/account-detail/cgl/true" target="_blank"
                    >Conditions générales d'utilisations</a
                >* (requis)
            </mat-checkbox>

            <div class="loaderContainer" *ngIf="isAccountCreating">
                <mat-spinner style="margin: auto" [diameter]="50"></mat-spinner>
                <i>Création de votre compte Wanview, veuillez patienter...</i>
            </div>

            <div class="couple-column routerForm">
                <button
                    [disabled]="isAccountCreating"
                    mat-flat-button
                    color="primary"
                    (click)="finishRegister()"
                >
                    Valider et créer mon compte
                </button>
                <button mat-flat-button (click)="cancelRegisterPart2()">
                    Retour
                </button>
            </div>
        </div>
    </div>

    <div class="finishedContainer" *ngIf="currentMode === 24">
        <p style="text-align: center">
            <img
                src="https://wancomresource.s3.eu-west-3.amazonaws.com/sendMail.gif"
                class="sendMainGif"
                alt="sendMail"
            />
            Nous vous avons envoyé un mail de confirmation.
            <br />
            Suivez les instructions pour confirmer votre inscription.
            <br />
            <br />
            <i style="font-size: small">
                Pensez à vérifier vos spams si vous ne trouvez pas le mail
            </i>
        </p>
        <button
            class="finishRegisterBtn"
            (click)="goToLoginAfterRegister()"
            mat-raised-button
            color="primary"
        >
            Se connecter
        </button>
    </div>

    @if (currentMode === 3) {
    <div class="registerFormContainer">
        <mat-form-field
            style="width: 100%; margin: 5px 0 10px 0"
            appearance="outline"
        >
            <mat-label>Nom d'utilisateur ou Adresse mail</mat-label>
            <input
                type="text"
                name="searchUserName"
                id="searchedLogin"
                matInput
                autocomplete="email"
                inputmode="email"
                [(ngModel)]="searchUserName"
                maxlength="500"
                required
            />
        </mat-form-field>

        <!-- Récupération de mot de passe -->
        <div class="couple-inline">
            <button
                (click)="currentMode = 4"
                mat-stroked-button
                color="secondary"
            >
                Retour
            </button>
            <button
                [disabled]="
                    searchUserName == null ||
                    searchUserName === '' ||
                    isTryingToLogIn
                "
                class="login-btn"
                mat-flat-button
                color="primary"
                (click)="forgotPassword()"
            >
                <mat-icon *ngIf="isTryingToLogIn">
                    <mat-spinner
                        color="secondary"
                        [diameter]="15"
                    ></mat-spinner>
                </mat-icon>
                Récupérer mon mot de passe
            </button>
        </div>
    </div>
    }

    <!-- Siret déjà existant -->
    @if (currentMode === 5) {
    <div class="registerFormContainer">
        @if (existingOrgaContact != null) {

        <h3>
            Vous êtes déjà client chez Wancom ? <br />
            Contactez votre commercial pour qu'il vous octroie des accès Wanview
        </h3>

        <h4>Entreprise déjà existante</h4>
        <div class="couple-inline">
            <mat-form-field appearance="outline">
                <mat-label>Nom de l'entreprise</mat-label>
                <mat-icon matPrefix>domain</mat-icon>
                <input
                    readonly="true"
                    matInput
                    [(ngModel)]="existingOrgaContact.orgaName"
                />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Siret</mat-label>
                <mat-icon matPrefix>domain</mat-icon>
                <input
                    readonly="true"
                    matInput
                    [(ngModel)]="existingOrgaContact.siret"
                />
            </mat-form-field>
        </div>
        <h4>Informations du Commercial</h4>
        <div class="couple-inline">
            <mat-form-field appearance="outline">
                <mat-label>Prénom</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input
                    readonly="true"
                    matInput
                    [(ngModel)]="existingOrgaContact.commercialInfos.firstName"
                />
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Nom</mat-label>
                <mat-icon matPrefix>person</mat-icon>
                <input
                    readonly="true"
                    matInput
                    [(ngModel)]="existingOrgaContact.commercialInfos.lastName"
                />
            </mat-form-field>
        </div>
        <h4>Coordonnées du Commercial</h4>
        <div class="couple-inline">
            <mat-form-field appearance="outline">
                <mat-label>Mail</mat-label>
                <mat-icon matPrefix>mail</mat-icon>
                <input
                    readonly="true"
                    matInput
                    [(ngModel)]="existingOrgaContact.commercialInfos.email"
                />
                <button
                    *ngIf="existingOrgaContact.commercialInfos?.email != null"
                    matSuffix
                    mat-icon-button
                    aria-label="send_mail"
                    (click)="
                        sendMail(existingOrgaContact.commercialInfos.email)
                    "
                >
                    <mat-icon>send</mat-icon>
                </button>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>Nom</mat-label>
                <mat-icon matPrefix>phone</mat-icon>
                <input
                    readonly="true"
                    matInput
                    [(ngModel)]="existingOrgaContact.commercialInfos.phone"
                />
                <button
                    *ngIf="existingOrgaContact.commercialInfos?.phone != null"
                    matSuffix
                    mat-icon-button
                    aria-label="call"
                    (click)="
                        callPhone(existingOrgaContact.commercialInfos.phone)
                    "
                >
                    <mat-icon>send</mat-icon>
                </button>
            </mat-form-field>
        </div>
        }@else{
        <div>Aucune information de contact</div>
        }

        <div class="couple-inline">
            <button
                (click)="currentMode = 22"
                mat-stroked-button
                color="secondary"
            >
                Retour
            </button>
            <button
                class="login-btn"
                mat-flat-button
                color="primary"
                (click)="currentMode = 4"
            >
                Retour à la page de connexion
            </button>
        </div>
    </div>
    }
</mat-dialog-content>
